export { PlusIcon } from './plus'
